import { render, staticRenderFns } from "./RedeliveryRequestQuickView.vue?vue&type=template&id=3edb3146&scoped=true&"
import script from "./RedeliveryRequestQuickView.vue?vue&type=script&lang=js&"
export * from "./RedeliveryRequestQuickView.vue?vue&type=script&lang=js&"
import style0 from "./RedeliveryRequestQuickView.vue?vue&type=style&index=0&id=3edb3146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edb3146",
  null
  
)

export default component.exports